<template>
  <div>
    <b-row vs-justify="center">
      <b-col cols="12">
        <b-card class="mb-4">
          <b-card-text>
            <h5 class="card-title">Control Icons</h5>
            <b-row class="icons">
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-user"></em> icon-user
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-people"></em> icon-people
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-user-female"></em> icon-user-female
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-user-follow"></em> icon-user-follow
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-user-following"></em> icon-user-following
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-user-unfollow"></em> icon-user-unfollow
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-login"></em> icon-login
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-logout"></em> icon-logout
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-emotsmile"></em> icon-emotsmile
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-phone"></em> icon-phone
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-call-end"></em> icon-call-end
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-call-in"></em> icon-call-in
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-call-out"></em> icon-call-out
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-map"></em> icon-map
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-location-pin"></em> icon-location-pin
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-direction"></em> icon-direction
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-directions"></em> icon-directions
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-compass"></em> icon-compass
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-layers"></em> icon-layers
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-menu"></em> icon-menu
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-list"></em> icon-list
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-options-vertical"></em> icon-options-vertical
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-options"></em> icon-options
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-arrow-down"></em> icon-arrow-down
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-arrow-left"></em> icon-arrow-left
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-arrow-right"></em> icon-arrow-right
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-arrow-up"></em> icon-arrow-up
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-arrow-up-circle"></em> icon-arrow-up-circle
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-arrow-left-circle"></em>
                icon-arrow-left-circle
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-arrow-right-circle"></em>
                icon-arrow-right-circle
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-arrow-down-circle"></em>
                icon-arrow-down-circle
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-check"></em> icon-check
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-clock"></em> icon-clock
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-plus"></em> icon-plus
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-close"></em> icon-close
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-trophy"></em> icon-trophy
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-screen-smartphone"></em>
                icon-screen-smartphone
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-screen-desktop"></em> icon-screen-desktop
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-plane"></em> icon-plane
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-notebook"></em> icon-notebook
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-mustache"></em> icon-mustache
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-mouse"></em> icon-mouse
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-magnet"></em> icon-magnet
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-energy"></em> icon-energy
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-disc"></em> icon-disc
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-cursor"></em> icon-cursor
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-cursor-move"></em> icon-cursor-move
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-crop"></em> icon-crop
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-chemistry"></em> icon-chemistry
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-speedometer"></em> icon-speedometer
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-shield"></em> icon-shield
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-screen-tablet"></em> icon-screen-tablet
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-magic-wand"></em> icon-magic-wand
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-hourglass"></em> icon-hourglass
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-graduation"></em> icon-graduation
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-ghost"></em> icon-ghost
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-game-controller"></em> icon-game-controller
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-fire"></em> icon-fire
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-eyeglass"></em> icon-eyeglass
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-envelope-open"></em> icon-envelope-open
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-envolope-letter"></em> icon-envolope-letter
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-bell"></em> icon-bell
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-badge"></em> icon-badge
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-anchor"></em> icon-anchor
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-wallet"></em> icon-wallet
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-vector"></em> icon-vector
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-speech"></em> icon-speech
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-puzzle"></em> icon-puzzle
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-printer"></em> icon-printer
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-present"></em> icon-present
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-playlist"></em> icon-playlist
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-pin"></em> icon-pin
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-picture"></em> icon-picture
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-handbag"></em> icon-handbag
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-globe-alt"></em> icon-globe-alt
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-globe"></em> icon-globe
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-folder-alt"></em> icon-folder-alt
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-folder"></em> icon-folder
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-film"></em> icon-film
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-feed"></em> icon-feed
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-drop"></em> icon-drop
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-drawar"></em> icon-drawar
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-docs"></em> icon-docs
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-doc"></em> icon-doc
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-diamond"></em> icon-diamond
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-cup"></em> icon-cup
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-calculator"></em> icon-calculator
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-bubbles"></em> icon-bubbles
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-briefcase"></em> icon-briefcase
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-book-open"></em> icon-book-open
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-basket-loaded"></em> icon-basket-loaded
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-basket"></em> icon-basket
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-bag"></em> icon-bag
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-action-undo"></em> icon-action-undo
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-action-redo"></em> icon-action-redo
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-wrench"></em> icon-wrench
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-umbrella"></em> icon-umbrella
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-trash"></em> icon-trash
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-tag"></em> icon-tag
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-support"></em> .icon-support
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-frame"></em> icon-frame
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-size-fullscreen"></em> icon-size-fullscreen
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-size-actual"></em> icon-size-actual
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-shuffle"></em> icon-shuffle
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-share-alt"></em> icon-share-alt
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-share"></em> icon-share
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-rocket"></em> icon-rocket
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-question"></em> icon-question
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-pie-chart"></em> icon-pie-chart
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-pencil"></em> icon-pencil
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-note"></em> icon-note
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-loop"></em> icon-loop
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-home"></em> icon-home
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-grid"></em> icon-grid
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-graph"></em> icon-graph
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-microphone"></em> icon-microphone
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-music-tone-alt"></em> icon-music-tone-alt
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-music-tone"></em> icon-music-tone
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-earphones-alt"></em> icon-earphones-alt
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-earphones"></em> icon-earphones
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-equalizer"></em> icon-equalizer
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-like"></em> icon-like
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-dislike"></em> icon-dislike
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-control-start"></em> icon-control-start
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-control-rewind"></em> icon-control-rewind
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-control-play"></em> icon-control-play
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-control-pause"></em> icon-control-pause
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-control-forward"></em> icon-control-forward
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-control-end"></em> icon-control-end
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-volume-1"></em> icon-volume-1
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-volume-2"></em> icon-volume-2
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-volume-off"></em> icon-volume-off
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-calender"></em> icon-calender
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-bulb"></em> icon-bulb
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-chart"></em> icon-chart
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-ban"></em> icon-ban
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-bubble"></em> icon-bubble
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-camrecorder"></em> icon-camrecorder
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-camera"></em> icon-camera
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-cloud-download"></em> icon-cloud-download
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-cloud-upload"></em> icon-cloud-upload
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-eye"></em> icon-eye
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-flag"></em> icon-flag
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-heart"></em> icon-heart
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-info"></em> icon-info
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-key"></em> icon-key
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-link"></em> icon-link
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-lock"></em> icon-lock
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-lock-open"></em> icon-lock-open
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-magnifier"></em> icon-magnifier
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-magnifier-add"></em> icon-magnifier-add
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-magnifier-remove"></em> icon-magnifier-remove
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-paper-clip"></em> icon-paper-clip
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-paper-plane"></em> icon-paper-plane
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-power"></em> icon-power
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-refresh"></em> icon-refresh
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-reload"></em> icon-reload
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-settings"></em> icon-settings
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-star"></em> icon-star
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-symble-female"></em> icon-symble-female
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-symbol-male"></em> icon-symbol-male
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-target"></em> icon-target
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-credit-card"></em> icon-credit-card
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-paypal"></em> icon-paypal
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-social-tumblr"></em> icon-social-tumblr
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-social-twitter"></em> icon-social-twitter
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-social-facebook"></em> icon-social-facebook
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-social-instagram"></em> icon-social-instagram
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-social-linkedin"></em> icon-social-linkedin
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-social-pintarest"></em> icon-social-pintarest
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-social-github"></em> icon-social-github
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-social-gplus"></em> icon-social-gplus
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-social-reddit"></em> icon-social-reddit
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-social-skype"></em> icon-social-skype
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-social-dribbble"></em> icon-social-dribbble
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-social-behance"></em> icon-social-behance
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-social-foursqare"></em> icon-social-foursqare
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-social-soundcloud"></em>
                icon-social-soundcloud
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-social-spotify"></em> icon-social-spotify
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-social-stumbleupon"></em>
                icon-social-stumbleupon
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-social-youtube"></em> icon-social-youtube
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 icon-social-dropbox"></em> icon-social-dropbox
              </b-col>
            </b-row>
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "SimpleLineIcons",
  data: () => ({
    page: {
      title: "Simple line Icons",
    },
    breadcrumbs: [
      {
        text: "Icons",
        disabled: false,
        to: "#",
      },
      {
        text: "Simple line Icons",
        disabled: true,
      },
    ],
  }),
};
</script>